<template>
<div class="card-row card-row-show">
 <div class="card-row-col card-col wp15">
   <div class="link">
   <router-link :to="{ name: 'WalletShow', params: { transporterId: wallet.transporter_id }}">
     {{wallet.transporter}}
    </router-link>
  </div>
 </div>

  <div class="card-row-col card-col wp15">
    {{wallet.transporter_ref}}
  </div>

  <div class="card-row-col card-col wp15">
   {{wallet.amount}}
 </div>
</div>
</template>

<script>
export default {
  props: ['wallet'],
};
</script>
